(function(){
  var languageHandles=['engels','duits','frans','spaans','nederlands','italiaans','portugees','andere-talen'];
  var timer;
  var collectionRequest=0;
  var pageSizeState='';

  function collectionHandle(){
    var m=window.location.pathname.match(/^\/collections\/([^/?#]+)/);
    return m?decodeURIComponent(m[1]):'';
  }

  function rewriteTalenLinks(root){
    (root||document).querySelectorAll('a[href]').forEach(function(a){
      var label=(a.textContent||'').replace(/\s+/g,' ').trim();
      if(label!=='Talen')return;
      try{
        var url=new URL(a.href,window.location.origin);
        if(url.pathname==='/collections/andere-talen')a.href='/collections?view=talen';
      }catch(e){}
    });
  }

  function addPortugueseRoute(){
    var nav=document.querySelector('.language-landing__routes');
    if(!nav||nav.querySelector('a[href*="/collections/portugees"]'))return;
    var other=nav.querySelector('a[href*="/collections/andere-talen"]');
    var link=document.createElement('a');
    link.href='/collections/portugees';
    link.textContent='Portugees';
    if(collectionHandle()==='portugees')link.setAttribute('aria-current','page');
    if(other)nav.insertBefore(link,other);else nav.appendChild(link);
  }

  function markContext(){
    if(!document.body.classList.contains('template-collection'))return;
    var handle=collectionHandle();
    if(languageHandles.indexOf(handle)!==-1)document.body.classList.add('intertaal-language-collection');
    var preorder=handle==='pre-order'||handle==='top-pre-orders'||document.body.classList.contains('template-suffix-preorder');
    document.body.classList.toggle('intertaal-preorder-collection',preorder);
    document.body.classList.toggle('intertaal-mixed-collection',!preorder);
  }

  function getCollectionSection(){
    return document.querySelector('[data-section-type="collection"]');
  }

  function injectCollectionSearch(){
    if(!document.body.classList.contains('template-collection'))return;
    if(document.querySelector('.intertaal-collection-tools'))return;
    var section=getCollectionSection();
    if(!section)return;
    var toolbar=section.querySelector('.collection__toolbar');
    if(!toolbar)return;
    var tools=document.createElement('div');
    tools.className='intertaal-collection-tools';
    var action=(window.routes&&window.routes.searchUrl)||'/search';
    tools.innerHTML='<div class="intertaal-collection-tools__inner"><div><span class="intertaal-collection-tools__eyebrow">SNEL VINDEN</span><h2>Vind direct het juiste product</h2><p>Zoek op titel, auteur, ISBN of trefwoord en vind snel wat je zoekt.</p></div><form class="intertaal-collection-search" action="'+action+'" method="get" role="search"><input type="hidden" name="type" value="product"><input type="hidden" name="options[prefix]" value="last"><label class="visually-hidden" for="intertaal-collection-search">Zoek een product</label><input id="intertaal-collection-search" name="q" type="search" required placeholder="Titel, auteur, ISBN of trefwoord"><button type="submit">Zoeken →</button></form></div>';
    toolbar.parentNode.insertBefore(tools,toolbar);
  }

  function injectToolbarStyles(){
    var style=document.getElementById('intertaal-collection-toolbar-styles');
    if(!style){
      style=document.createElement('style');
      style.id='intertaal-collection-toolbar-styles';
      document.head.appendChild(style);
    }
    style.textContent='.template-collection .collection__toolbar-item--layout{display:none!important}.template-collection .collection__toolbar-item--count{gap:18px!important}.template-collection .collection__toolbar-item--sort{border-right:0!important}.intertaal-collection-control{display:flex;align-items:center;gap:9px;min-width:0}.intertaal-collection-control__label{white-space:nowrap;color:#4e474b;font-size:14px}.intertaal-collection-control__select-wrap{position:relative;display:block;min-width:150px}.intertaal-collection-control--sort .intertaal-collection-control__select-wrap{min-width:200px}.intertaal-collection-control__select-wrap:after{content:"⌄";position:absolute;right:12px;top:50%;transform:translateY(-55%);pointer-events:none;color:#625b5f;font-size:15px}.intertaal-collection-control select{appearance:none;-webkit-appearance:none;width:100%;height:42px;padding:0 34px 0 12px;border:1px solid rgba(37,33,35,.13);border-radius:11px;background:#fff;color:#272225;font:inherit;font-size:14px;cursor:pointer;outline:none}.intertaal-collection-control select:focus{border-color:rgba(210,112,28,.55);box-shadow:0 0 0 3px rgba(210,112,28,.10)}.intertaal-collection-control select:disabled{cursor:wait;opacity:.66}.template-collection .collection__dynamic-part.intertaal-is-loading .product-list,.template-collection .collection__dynamic-part.intertaal-is-loading .pagination{opacity:.5;pointer-events:none;transition:opacity .15s ease}@media(max-width:1000px){.intertaal-collection-control__label{display:none}.intertaal-collection-control--sort .intertaal-collection-control__select-wrap{min-width:175px}}@media(max-width:740px){.intertaal-collection-control__select-wrap,.intertaal-collection-control--sort .intertaal-collection-control__select-wrap{min-width:145px;max-width:48vw}.intertaal-collection-control select{height:40px;font-size:13px;padding-left:10px}.template-collection .collection__toolbar-item--sort{padding-left:8px!important;padding-right:8px!important}}';
  }

  function forceGridOnly(){
    if(!document.body.classList.contains('template-collection'))return;
    var section=getCollectionSection();
    if(!section)return;
    var listButton=section.querySelector('.collection__layout-button[data-layout-mode="list"].is-selected');
    var gridButton=section.querySelector('.collection__layout-button[data-layout-mode="grid"]');
    if(listButton&&gridButton&&!gridButton.dataset.intertaalGridForced){
      gridButton.dataset.intertaalGridForced='true';
      gridButton.click();
    }
  }

  function cleanChoiceText(choice){
    return (choice.textContent||'').replace(/\s+/g,' ').trim();
  }

  function buildControl(type,labelText,choices,current){
    var label=document.createElement('label');
    label.className='intertaal-collection-control intertaal-collection-control--'+type;
    label.setAttribute('data-intertaal-'+type,'');
    var text=document.createElement('span');
    text.className='intertaal-collection-control__label';
    text.textContent=labelText;
    var wrap=document.createElement('span');
    wrap.className='intertaal-collection-control__select-wrap';
    var select=document.createElement('select');
    select.setAttribute('aria-label',labelText.replace(':',''));
    choices.forEach(function(choice){
      var option=document.createElement('option');
      option.value=choice.value;
      option.textContent=choice.label;
      if(option.value===current)option.selected=true;
      select.appendChild(option);
    });
    select.dataset.currentValue=current;
    wrap.appendChild(select);
    label.appendChild(text);
    label.appendChild(wrap);
    return label;
  }

  function setControlsBusy(busy){
    document.querySelectorAll('[data-intertaal-page-size] select,[data-intertaal-sort] select').forEach(function(select){
      select.disabled=busy;
    });
  }

  function syncPageSizeControl(value){
    value=String(value||'');
    if(!value)return;
    var select=document.querySelector('[data-intertaal-page-size] select');
    if(!select)return;
    select.value=value;
    select.dataset.currentValue=value;
  }

  function syncOutsideDynamic(section,nextSection,displayUrl){
    if(nextSection){
      ['.collection__products-count-total','.collection__products-count-showing'].forEach(function(selector){
        var current=section.querySelector(selector);
        var next=nextSection.querySelector(selector);
        if(current&&next)current.textContent=next.textContent;
      });
    }
    var sortValue=displayUrl.searchParams.get('sort_by');
    if(sortValue){
      section.querySelectorAll('input[name="sort_by"]').forEach(function(input){input.value=sortValue;});
      try{
        var settings=JSON.parse(section.getAttribute('data-section-settings')||'{}');
        settings.currentSortBy=sortValue;
        section.setAttribute('data-section-settings',JSON.stringify(settings));
      }catch(e){}
    }
  }

  function reloadCollection(url,historyMode){
    var section=getCollectionSection();
    if(!section)return Promise.reject(new Error('Collection section not found'));
    var sectionId=section.getAttribute('data-section-id');
    if(!sectionId)return Promise.reject(new Error('Collection section id not found'));

    var displayUrl=url instanceof URL?new URL(url.toString()):new URL(url||window.location.href,window.location.origin);
    displayUrl.searchParams.delete('section_id');
    var requestUrl=new URL(displayUrl.toString());
    requestUrl.searchParams.set('section_id',sectionId);

    var dynamic=section.querySelector('.collection__dynamic-part');
    if(dynamic)dynamic.classList.add('intertaal-is-loading');
    setControlsBusy(true);

    var requestId=++collectionRequest;

    return fetch(requestUrl.toString(),{
      method:'GET',
      credentials:'same-origin',
      headers:{'X-Requested-With':'XMLHttpRequest'}
    }).then(function(response){
      if(!response.ok)throw new Error('Collection request failed');
      return response.text();
    }).then(function(html){
      if(requestId!==collectionRequest)return;
      var doc=new DOMParser().parseFromString(html,'text/html');
      var nextSection=doc.querySelector('[data-section-type="collection"]');
      var nextDynamic=(nextSection&&nextSection.querySelector('.collection__dynamic-part'))||doc.querySelector('.collection__dynamic-part');
      var currentSection=getCollectionSection();
      var currentDynamic=currentSection&&currentSection.querySelector('.collection__dynamic-part');
      if(!nextDynamic||!currentDynamic)throw new Error('Collection response incomplete');

      currentDynamic.replaceWith(nextDynamic);
      syncOutsideDynamic(currentSection,nextSection,displayUrl);

      if(historyMode==='push'){
        window.history.pushState({intertaalCollection:true},'',displayUrl.pathname+displayUrl.search+displayUrl.hash);
      }else if(historyMode==='replace'){
        window.history.replaceState({intertaalCollection:true},'',displayUrl.pathname+displayUrl.search+displayUrl.hash);
      }

      init();
    }).catch(function(error){
      var current=getCollectionSection();
      var currentDynamic=current&&current.querySelector('.collection__dynamic-part');
      if(currentDynamic)currentDynamic.classList.remove('intertaal-is-loading');
      setControlsBusy(false);
      throw error;
    });
  }

  function cartUpdateUrl(){
    if(window.routes&&window.routes.cartUpdateUrl)return window.routes.cartUpdateUrl;
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    if(root.slice(-1)!=='/')root+='/';
    return root+'cart/update.js';
  }

  function setPageSize(value){
    setControlsBusy(true);
    return fetch(cartUpdateUrl(),{
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify({attributes:{collection_products_per_page:String(value)}})
    }).then(function(response){
      if(!response.ok)throw new Error('Page size could not be saved');
      return response.json();
    }).then(function(cart){
      pageSizeState=String((cart.attributes&&cart.attributes.collection_products_per_page)||value);
      var url=new URL(window.location.href);
      url.searchParams.delete('page');
      return reloadCollection(url,'replace');
    }).then(function(){
      syncPageSizeControl(pageSizeState);
    });
  }

  function upgradePageSize(){
    if(!document.body.classList.contains('template-collection'))return;
    var section=getCollectionSection();
    if(!section)return;
    var item=section.querySelector('.collection__toolbar-item--count');
    if(!item||item.querySelector('[data-intertaal-page-size]'))return;
    var picker=item.querySelector('.value-picker-wrapper');
    if(!picker)return;
    var nativeChoices=picker.querySelectorAll('.value-picker__choice-item[data-value]');
    if(!nativeChoices.length)return;

    var choices=[];
    var current=pageSizeState||'';
    nativeChoices.forEach(function(choice){
      var value=choice.getAttribute('data-value')||'';
      choices.push({value:value,label:value+' per pagina'});
      if(!current&&choice.classList.contains('is-selected'))current=value;
    });
    if(!current)current=choices[0].value;
    pageSizeState=current;

    var control=buildControl('page-size','Weergave:',choices,current);
    var select=control.querySelector('select');
    select.addEventListener('change',function(){
      var previous=select.dataset.currentValue||current;
      var next=select.value;
      if(next===previous)return;
      setPageSize(next).catch(function(){
        pageSizeState=previous;
        select.value=previous;
        select.dataset.currentValue=previous;
      }).finally(function(){
        setControlsBusy(false);
      });
    });
    picker.replaceWith(control);
  }

  function upgradeCollectionSort(){
    if(!document.body.classList.contains('template-collection'))return;
    var section=getCollectionSection();
    if(!section)return;
    var item=section.querySelector('.collection__toolbar-item--sort');
    if(!item||item.querySelector('[data-intertaal-sort]'))return;
    var picker=item.querySelector('.value-picker-wrapper');
    if(!picker)return;
    var nativeChoices=picker.querySelectorAll('.value-picker__choice-item[data-value]');
    if(!nativeChoices.length)return;

    var choices=[];
    var current=new URL(window.location.href).searchParams.get('sort_by')||'';
    nativeChoices.forEach(function(choice){
      var value=choice.getAttribute('data-value')||'';
      choices.push({value:value,label:cleanChoiceText(choice)});
      if(!current&&choice.classList.contains('is-selected'))current=value;
    });
    if(!current)current=choices[0].value;

    var control=buildControl('sort','Sorteren op:',choices,current);
    var select=control.querySelector('select');
    select.addEventListener('change',function(){
      var previous=select.dataset.currentValue||current;
      var next=select.value;
      if(next===previous)return;
      var url=new URL(window.location.href);
      url.searchParams.set('sort_by',next);
      url.searchParams.delete('page');
      reloadCollection(url,'push').catch(function(){
        select.value=previous;
      }).finally(function(){
        setControlsBusy(false);
      });
    });
    picker.replaceWith(control);
  }

  function init(){
    rewriteTalenLinks(document);
    markContext();
    addPortugueseRoute();
    injectCollectionSearch();
    injectToolbarStyles();
    forceGridOnly();
    upgradePageSize();
    if(pageSizeState)syncPageSizeControl(pageSizeState);
    upgradeCollectionSort();
  }

  function schedule(){
    window.clearTimeout(timer);
    timer=window.setTimeout(init,60);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  window.addEventListener('load',function(){window.setTimeout(init,120);});
  window.addEventListener('popstate',function(){
    if(document.body.classList.contains('template-collection')){
      reloadCollection(new URL(window.location.href),null).catch(function(){});
    }
  });

  new MutationObserver(function(mutations){
    var changed=mutations.some(function(m){return m.addedNodes&&m.addedNodes.length;});
    if(changed)schedule();
  }).observe(document.documentElement,{childList:true,subtree:true});
})();